__turbopack_context__.v({
  "flavorText": "splashPage-module-scss-module__S_GMHG__flavorText",
});
